<template>
  <section>
    <div class="row">
      <div class="col">
        <h5>Thank You!</h5>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col">
        <p>Subscription and payment successfully established. Please use the following credentials to log into Invoices AI.</p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <ul class="custom-list">
          <li><span class="custom-label">Username:</span> {{ username }}</li>
          <li><span class="custom-label">Password:</span> {{ password }}</li>
        </ul>
        <p class="mt-2"><b class="text-danger">Please save these credentials</b>. You can change your password once logged in.</p>
      </div>
    </div>
    <div class="row mt-3 mb-3">
      <div class="col text-center">
        <button class="btn btn-primary" :disabled="!allGood" @click="gotoLogin()">Goto Login</button>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'OnboardThankYou',
  data() {
    return {
      allGood: false,
      username: '',
      password: ''
    }
  },
  methods: {
    setAllGood(value) {
      console.log('Setting All Good', value)
      this.allGood = value
    },
    setResults(data) {
      this.username = data.email
      this.password = data.password
    },
    gotoLogin() {
      this.$router.push('/login')
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.custom-label {
  font-weight: 500;
}
</style>
